import { useSelector } from 'react-redux'
import { RootState } from '../store/store'

/** Features nutricionales que implican acceso al asistente si el plan olvidó la key `chatbot`. */
const CHATBOT_PROXY_FEATURES = ['food_log', 'personal_nutrition', 'macro_calculator']
/** Escáner: si el plan tiene nutrición básica pero omitió `barcode_scanner` (parity antigua). */
const BARCODE_PROXY_FEATURES = ['food_log', 'personal_nutrition', 'macro_calculator']
const PHOTO_LOG_PROXY_FEATURES = ['food_log', 'personal_nutrition', 'macro_calculator', 'barcode_scanner']

function planHasFeature(features: string[], featureKey: string): boolean {
  if (features.includes('all') || features.includes(featureKey)) return true
  // Evita que Chat Nico desaparezca en prod cuando el plan trae nutrición pero no la key chatbot.
  if (featureKey === 'chatbot') {
    return CHATBOT_PROXY_FEATURES.some((f) => features.includes(f))
  }
  if (featureKey === 'barcode_scanner') {
    return BARCODE_PROXY_FEATURES.some((f) => features.includes(f))
  }
  if (featureKey === 'photo_food_log') {
    return PHOTO_LOG_PROXY_FEATURES.some((f) => features.includes(f))
  }
  return false
}

export function useFeature(featureKey: string): boolean {
  const { user, subscription } = useSelector((s: RootState) => s.auth)

  // Admins and trainers always have access
  if (user?.role === 'SUPER_ADMIN' || user?.role === 'ADMIN' || user?.role === 'TRAINER') {
    return true
  }

  // Check features in subscription plan
  const features: string[] = subscription?.plan?.features || []
  return planHasFeature(features, featureKey)
}

export function useFeatures(): string[] {
  const { user, subscription } = useSelector((s: RootState) => s.auth)
  if (user?.role === 'SUPER_ADMIN' || user?.role === 'ADMIN' || user?.role === 'TRAINER') {
    return ['all']
  }
  const features: string[] = subscription?.plan?.features || []
  if (
    features.length > 0
    && !features.includes('chatbot')
    && CHATBOT_PROXY_FEATURES.some((f) => features.includes(f))
  ) {
    return [...features, 'chatbot']
  }
  return features
}
